import {
  adminDangerGhostBtnClass,
  ghostBtnClass,
  mfgConfirmDialogClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

type Props = {
  open: boolean;
  busy: boolean;
  counted: number;
  total: number;
  onCancel: () => void;
  onAccept: () => void;
};

export function ManufacturingInventoryCountDiscardConfirm({
  open,
  busy,
  counted,
  total,
  onCancel,
  onAccept,
}: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="inventory-count-discard-title"
        className={`max-w-lg w-full ${mfgConfirmDialogClass}`}
      >
        <h3
          id="inventory-count-discard-title"
          className="text-base font-semibold text-gray-900 dark:text-zinc-50"
        >
          Discard this inventory count?
        </h3>
        <p className="mt-1 text-sm text-gray-600 dark:text-zinc-300">
          Archives the session ({counted} of {total} counted). No stock adjustments will be
          posted. You can start a new count afterward.
        </p>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" className={ghostBtnClass} onClick={onCancel} disabled={busy}>
            Keep counting
          </button>
          <button
            type="button"
            className={adminDangerGhostBtnClass}
            onClick={onAccept}
            disabled={busy}
          >
            {busy ? "Archiving…" : "Discard (archive)"}
          </button>
        </div>
      </div>
    </div>
  );
}
